import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
const STORAGE_KEY = "premierlab.theme";

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem(STORAGE_KEY) || "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark", "creator", "light");
    if (theme === "dark") root.classList.add("dark");
    if (theme === "creator") root.classList.add("dark", "creator");
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const cycle = () => {
    setTheme((t) => (t === "dark" ? "light" : t === "light" ? "creator" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, cycle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
